import {
  Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Typography, makeStyles,
} from "@material-ui/core";
import _, { isEmpty, isFunction } from 'lodash';
import { useContext, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

import DeclaracaoImportacaoContext from '../../../../../contexts/import/declaracao-importacao/DeclaracaoImportacaoContext';
import { selectDeclaracaoImportacao } from '../../../../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import QCXFinalFormWizard from '../../../../../shared-components/final-form-wizard/QCXFinalFormWizard';
import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import AdicaoResumoFormStepWizard from './AdicaoResumoFormStepWizard';
import VisaoGeral from './VisaoGeralFormStepWizard';


const useStyles = makeStyles({
  paper: {
      maxWidth: '80%',
      width: 800,
      '@media (max-width: 900px)': {
          maxWidth: '100%',
          width: '100%',
      },
  },
  title: {
      borderBottom: '2px solid #000000',
  },
});


const RelatorioCalculoFinalFormWizard = ({ isModalOpen, setIsModalOpen, ...restProps }) => {

  const { t } = useTranslation();

  const wizardSteps = [
    t('com.muralis.qcx.dadosTecnicos').toUpperCase(),
    'ADIÇÕES',
  ];


  return (
    <>
      <QCXFinalFormWizard
        steps={wizardSteps}
        handleChangeValues={() => null}
        isConsult
        isUpdate={false}
        handleSubmit={() => null}
        {...restProps}
      >
      {(formProps) => (
        <VisaoGeral
          key="ficha-relatorio-di"
          {...formProps}
        />
      )}
      {(formProps) => (
        <AdicaoResumoFormStepWizard
          key="ficha-relatorio-adicoes-di"
          {...formProps}
        />
      )}
      </QCXFinalFormWizard>
    </>
  )

}


export default RelatorioCalculoFinalFormWizard;